import React from 'react';
import Badge from '../atoms/Badge';
import Text from '../atoms/Text';

const FeatureCard = ({
  icon,
  title,
  description,
  features = [],
  className = ''
}) => {
  return (
    <div className={`bg-white rounded-xl shadow-lg p-6 md:p-8 text-center hover:-translate-y-2 hover:shadow-xl transition-all duration-300 ${className}`}>
      {icon && (
        <div className="text-4xl mb-4">{icon}</div>
      )}
      <h3 className="text-xl font-bold mb-4">{title}</h3>
      <Text className="mb-4">{description}</Text>
      {features.length > 0 && (
        <ul className="space-y-2">
          {features.map((feature, index) => (
            <li key={index} className="flex items-center text-sm text-gray-600">
              <div className="w-2 h-2 bg-orange-500 rounded-full mr-3"></div>
              {feature}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default FeatureCard;
